import axios from './ResponseInterceptor';

export default axios;